import axios from "./api-service";

export const syncAll = () => {
  return axios().get("sync", { timeout: 300000 });
};

export const getSyncMeta = () => {
  return axios().get("sync/hash", { timeout: 300000 });
};

export const getSyncData = () => {
  return axios().get("sync/cache", { timeout: 300000 });
};
